import {
  faCheck,
  faTimes,
  faInfoCircle,
  faSearch,
  faWarning,
} from '@fortawesome/pro-regular-svg-icons'
import React from 'react'

import { Icon as IconUI, type IconProps as IconUIProps } from '../../../@shared'
import styles from './styles.module.css'

type IconProps = Omit<IconUIProps, 'icon' | 'size'> & {
  icon?: IconUIProps['icon']
  variant?: 'info' | 'warning' | 'error' | 'success' | 'empty'
}

const mapVariants = {
  info: {
    icon: faInfoCircle,
    color: 'blue',
  },
  warning: {
    icon: faWarning,
    color: 'orange',
  },
  error: {
    icon: faTimes,
    color: 'red',
  },
  success: {
    icon: faCheck,
    color: 'green',
  },
  empty: {
    icon: faSearch,
    color: 'gray',
  },
}

export function Icon({ color = 'gray', icon, variant }: IconProps) {
  let iconComponent = null

  if (icon) {
    iconComponent = (
      <IconUI
        icon={icon}
        color={color}
        data-testid='modal-icon'
        size='lg'
        withCircleBackground
        className={styles.icon}
      />
    )
  } else if (variant) {
    const iconDefinition = mapVariants[variant]

    iconComponent = (
      <IconUI
        icon={iconDefinition.icon}
        data-testid='modal-icon'
        size='lg'
        color={iconDefinition.color}
        withCircleBackground
        className={styles.icon}
      />
    )
  }

  return iconComponent
}

Icon.displayName = 'ModalIcon'
